import { useState } from "react";
import { Loader2 } from "lucide-react";

export const ContactForm = ({ onSubmit, busy }) => {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [sms, setSms] = useState(false);
  return (
    <form data-testid="game-contact-form" onSubmit={(e) => { e.preventDefault(); onSubmit({ email, phone, sms_opt_in: sms }); }} className="space-y-3">
      <input data-testid="game-email-input" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email address"
        className="w-full h-12 rounded-full bg-white border border-[#1B1530]/15 px-5 outline-none focus:ring-2 focus:ring-[#1B1530]" />
      <input data-testid="game-phone-input" type="tel" required autoComplete="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone number"
        className="w-full h-12 rounded-full bg-white border border-[#1B1530]/15 px-5 outline-none focus:ring-2 focus:ring-[#1B1530]" />
      <label className="flex items-start gap-2 text-xs text-[#4A4560] leading-snug">
        <input data-testid="game-sms-consent" type="checkbox" checked={sms} onChange={(e) => setSms(e.target.checked)} className="mt-0.5" />
        Text me restocks, new flavours and deals from Swole Bears. Msg &amp; data rates may apply. Reply STOP to opt out.
      </label>
      <button data-testid="game-open-bag-button" type="submit" disabled={busy}
        className="w-full h-12 rounded-full bg-[#FF5A5F] text-white font-bold inline-flex items-center justify-center gap-2 hover:bg-[#1B1530] transition-colors disabled:opacity-60">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Rip it open"}
      </button>
      <p className="text-[11px] text-center text-[#4A4560]">One mystery bag per person. By playing you agree to get emails from Swole Bears; unsubscribe anytime.</p>
    </form>
  );
};
